import React, { Component } from 'react';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import QcSampleDetails from './qcSampleDetails';
import Swal from 'sweetalert2';
import toastr from 'toastr';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { deleteQcSample } from '../../../../services/clinicPortalServices/qcSampleService';

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showCopyModal: false,
            show: false,
            qcSampleId: props.data._id
        };
    }

    handleCopy = () => {
        this.setState({ showCopyModal: true });
    };

    handleCloseCopyModal = () => {
        this.setState({ showCopyModal: false });
    };

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'This QC Sample will be archived!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, archive it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                deleteQcSample({
                    _id: this.state.qcSampleId,
                    name: this.props.data.name
                }).then((res) => {
                    this.props.context.componentParent.loadGridData();
                    toastr.success('QC Sample archived successfully');
                });
            }
        });
    };

    handleShow = () => {
        this.setState({ show: true });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit QC Sample
        </Tooltip>
    );

    renderTooltipDelete = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Archive QC Sample
        </Tooltip>
    );

    renderTooltipCopy = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Copy QC Sample
        </Tooltip>
    );

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipCopy}>
                    <button onClick={this.handleCopy} className="edit-order-btn">
                        <i className="fas fa-copy"></i>
                    </button>
                </OverlayTrigger>
                {!this.props.data.isArchived && (
                    <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                        <button onClick={this.handleShow} className="edit-order-btn">
                            <i className="fas fa-pen"></i>
                        </button>
                    </OverlayTrigger>
                )}
                {!this.props.data.isArchived && (
                    <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipDelete}>
                        <button onClick={this.handleDelete} className="edit-order-btn">
                            <i className="fas fa-trash"></i>
                        </button>
                    </OverlayTrigger>
                )}
                {!this.props.data.isArchived && (
                    <ModalStyled
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        show={this.state.show}
                        onHide={this.handleClose}
                        backdrop="static"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Update QC Sample Information</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <QcSampleDetails
                                qcSampleId={this.state.qcSampleId}
                                context={this.props.context}
                                handleClose={this.handleClose}
                            />
                        </Modal.Body>
                    </ModalStyled>
                )}
                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.showCopyModal}
                    onHide={this.handleCloseCopyModal}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Copy QC Sample</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <QcSampleDetails
                            qcSampleId={this.state.qcSampleId}
                            context={this.props.context}
                            handleClose={this.handleCloseCopyModal}
                            isCopy={true}
                            originalQcSampleId={this.state.qcSampleId}
                        />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
